export const MONTHS = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'];

export const DAYS = ['日','月','火','水','木','金','土'];



// WEBPACK FOOTER //
// ./src/utils/datetime.js